import { type FC, useMemo } from "react";
import { NavSelector } from "src/components/layout/nav/nav-selector";
import type { Space } from "./space-context";

export interface SpaceSelectorProps {
  selectedSpace: Space | null;
  availableSpaces: Space[];
  isUserSpaceScoped: boolean;
  isNavOpen: boolean;
  selectSpace: (space: Space | null) => void;
}

export const SpaceSelector: FC<SpaceSelectorProps> = ({
  selectedSpace,
  availableSpaces,
  isUserSpaceScoped,
  isNavOpen,
  selectSpace,
}) => {
  const menuOptions = useMemo(
    () =>
      availableSpaces.map((space) => ({
        active: selectedSpace?.id === space.id,
        label: space.name,
        onClick: () => selectSpace(space),
      })),
    [availableSpaces, selectedSpace?.id, selectSpace],
  );

  const displayLabel = selectedSpace?.name ?? "Full workspace access";

  // Disable if user is space scoped and only has access to one space
  const isDisabled = isUserSpaceScoped && availableSpaces.length === 1;

  return (
    <NavSelector
      ariaLabel="Select space"
      displayLabel={displayLabel}
      options={menuOptions}
      isNavOpen={isNavOpen}
      height={8}
      isDisabled={isDisabled}
      showSearchbar
      searchPlaceholder="Search spaces"
      topAction={
        !isUserSpaceScoped
          ? {
              label: "Full workspace access",
              onClick: () => selectSpace(null),
            }
          : undefined
      }
    />
  );
};
